import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/resume-keyword-extractor/KeywordExtractorContent.tsx");
